module.exports = __webpack_public_path__ + "img/icon-home-notice.4a369a33.svg";